export function Wrapper({ children }) {
  return (
    <div className="login_content">
      <div className="login_box">
        <div className="login_form">
          <div className="logo margin_logo">
            <img src="/diva_mini_logo_yellow.svg" alt="" />
          </div>
          <div className="login_form_box">{children}</div>
        </div>
      </div>
    </div>
  );
}
